import script from "./TimelineSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineSidebar.vue?vue&type=script&setup=true&lang=js"

import "./TimelineSidebar.vue?vue&type=style&index=0&id=2ffa9ed0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffa9ed0"]])

export default __exports__